import { Navigate } from 'react-router-dom';

import { FeatureFlag } from '@ndvr/auth-api';
import { HouseholdType } from '@ndvr/customer-api';

import { usePageVersion } from '@/hooks/usePageVersion';
import { useHouseholdRouteType, useRequiredParams } from 'utils';
import { useAssignedFlags } from 'views/auth/auth-queries';
import { PageSpinner } from 'widgets';

import { useCommandCenterHouseholdProfile } from './household-queries';

export const HouseholdIndexRedirect = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);
    const { isHouseholdRoute, isOnboardingRoute } = useHouseholdRouteType();
    const { view, isPending } = usePageVersion();
    const { data: profile, isPending: isProfilePending } = useCommandCenterHouseholdProfile(globalAccountGUID);
    const { data: flags, isPending: isFlagsPending } = useAssignedFlags();
    if (isPending || isProfilePending || isFlagsPending) return <PageSpinner />;
    if (isHouseholdRoute && (isOnboardingRoute || profile?.globalAccount.householdType === HouseholdType.ONBOARDING)) {
        if (profile?.isOnboardingInProgress && flags?.includes(FeatureFlag.ONBOARDING)) {
            return <Navigate to="onboarding" replace />;
        }
        return <Navigate to="portfolio" replace />;
    }
    return <Navigate to={view === 'new' ? 'accounts' : 'portfolio'} replace />;
};
